<template>
    <NavbarComp :user="user" />
    <div id="main">
        <div class="w-full">
            <div class="bg-jc bg-no-repeat bg-cover mx-8 d-flex rounded-3xl">
                <div class="w-1/4">
                    <img src="../assets/pic-jc.png" class="rounded-bl-3xl md:w-min" alt="">
                </div>
                <div class="w-3/5 text-center text-[#023047] my-auto">
                    <h1 class="font-bold flex ">
                        Kerja Mudah Sampai Lolos Screening
                    </h1>
                    <h5 class="">Persiapkan dirimu dan mulailah membangun karir melalui
                        daftar
                        pekerjaan impian yang sudah
                        menunggumu di laman ini</h5>
                </div>
            </div>
        </div>
        <div id="second-section">
            <div class="text-right mx-8 mt-10 flex justify-end">
                <p class="mt-3 pr-3">
                    <span class="text-gray-300">11</span>
                    Pekerjaan
                    <span class="text-gray-300">- Sort by :</span>
                </p>
                <select id="underline_select"
                    class="block p-0 w-40 text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                    <option value="released_date">Released Date</option>
                    <option value="xx1">xxxx</option>
                    <option value="xx2">xxxx</option>
                    <option value="xx3">xxxx</option>
                </select>
            </div>
            <div class="flex mx-8 gap-y-4">
                <div class="w-1/4">
                    <div id="aside" class="w-auto border-1 p-4 mr-8 rounded-xl shadow-lg">
                        <div class="filter flex justify-between">
                            <div class="flex gap-x-2">
                                <img src="../assets/Icon-filter.png" alt="" class="w-4 h-4 mt-1">
                                <p class="m-0">Filter</p>
                            </div>
                            <a href="" class="text-gray-300 m-0 no-underline">Reset</a>
                        </div>

                        <div id="Tipe-perkerjaan" class="mt-3">
                            <h5>Tipe Pekerjaan</h5>
                            <ul
                                class="w-auto text-sm font-medium text-[#023047] bg-white rounded-lg flex flex-col gap-y-3 pl-0">
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="teal-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="teal-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Intership</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="purple-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="purple-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Freelance</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="angular-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="angular-checkbox"
                                            class="py-2 ml-2 w-full text-sm font-medium text-[#023047] dark:text-gray-300">Fulltime</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="laravel-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="laravel-checkbox"
                                            class="py-2 ml-2 w-full text-sm font-medium text-[#023047] dark:text-gray-300">Partime</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div id="Sistem" class="mt-3">
                            <h5>Sistem</h5>
                            <ul
                                class="w-auto text-sm font-medium text-[#023047] bg-white rounded-lg flex flex-col gap-y-3 pl-0">
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="teal-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="teal-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">WFA/WFH</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="purple-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="purple-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">WFO</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="angular-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="angular-checkbox"
                                            class="py-2 ml-2 w-full text-sm font-medium text-[#023047] dark:text-gray-300">Hybird</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div id="Daerah" class="mt-3">
                            <h5>Daerah</h5>
                            <ul
                                class="w-auto text-sm font-medium text-[#023047] bg-white rounded-lg flex flex-col gap-y-3 pl-0">
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="teal-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="teal-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Jawa
                                            Barat</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="purple-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="purple-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Jawa
                                            Tengah</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="angular-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="angular-checkbox"
                                            class="py-2 ml-2 w-full text-sm font-medium text-[#023047] dark:text-gray-300">Jawa
                                            Timur</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div id="Pengalaman" class="mt-3">
                            <h5>Pengalaman</h5>
                            <ul
                                class="w-auto text-sm font-medium text-[#023047] bg-white rounded-lg flex flex-col gap-y-3 pl-0">
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="teal-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="teal-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">0 - 1
                                            Tahun</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="purple-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="purple-checkbox"
                                            class="py-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">1 - 3
                                            Tahun</label>
                                    </div>
                                </li>
                                <li class="w-full rounded-lg border border-gray-200 dark:border-gray-600">
                                    <div class="flex items-center pl-3">
                                        <input id="angular-checkbox" type="checkbox" value=""
                                            class="w-4 h-4 text-[#023047] bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                                        <label for="angular-checkbox"
                                            class="py-2 ml-2 w-full text-sm font-medium text-[#023047] dark:text-gray-300">3+
                                            Tahun</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div id="article" class="w-3/4">
                    <div id="list-job" class="flex flex-col gap-y-2">
                        <div class="flex p-4 bg-[#FEEBD4] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/tokped.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Tokopedia, <span class="text-gray-400"><i>Ecommerce</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Jr. Data Scientiest</p>
                                    <p class="m-0">WFA - Jakarta</p>
                                    <p class="m-0">23 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FEEBD4] rounded-xl border">
                            <div class="w-28">
                                <img src="../assets/job/ruangguru.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Ruangguru, <span class="text-gray-400"><i>Pendidikan</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Data Scientiest</p>
                                    <p class="m-0">WFA - Tanggerang</p>
                                    <p class="m-0">20 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FEEBD4] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/intelligo.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Intelligo ID, <span class="text-gray-400"><i>Pendidikan</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Jr. Data Scientiest</p>
                                    <p class="m-0">WFA - Bandung</p>
                                    <p class="m-0">15 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/jnt.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">J&T, <span class="text-gray-400"><i>Logistic</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Jr. Data Scientiest</p>
                                    <p class="m-0">WFA - Banten</p>
                                    <p class="m-0">9 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/indomaret.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Indomaret, <span class="text-gray-400"><i>Marketplace</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Data Scientiest</p>
                                    <p class="m-0">WFA - Palembang</p>
                                    <p class="m-0">10 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/sicepat.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">SiCepat, <span class="text-gray-400"><i>Logistic</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Jr. Data Scientiest</p>
                                    <p class="m-0">WFA - Bandung</p>
                                    <p class="m-0">5 Nov</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/google.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Google Inc, <span class="text-gray-400"><i>Tech</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Data Scientiest Internship</p>
                                    <p class="m-0">WFA - USA</p>
                                    <p class="m-0">30 Oct</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/meta.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Meta, <span class="text-gray-400"><i>Social Media</i></span></p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Associates Data Scientiest</p>
                                    <p class="m-0">WFO - California</p>
                                    <p class="m-0">24 Oct</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                        <div class="flex p-4 bg-[#FDFDFD] rounded-xl border">
                            <div class="w-28 ">
                                <img src="../assets/job/niagahoster.png" class="rounded-lg w-28 h-28 border-1" alt="">
                            </div>
                            <div class="w-4/5 flex flex-col justify-center my-0 ml-8 gap-y-1">
                                <p class="m-0">Niagahoster, <span class="text-gray-400"><i>Layanan Hosting</i></span>
                                </p>
                                <div class="flex justify-content-between align-center w-full m-0">
                                    <p class="text-lg m-0">Associates Data Scientiest</p>
                                    <p class="m-0">Hybird - Yogyakarta</p>
                                    <p class="m-0">15 Oct</p>
                                </div>
                                <p class="m-0 text-sm">Fulltime</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full">
            <div class="flex mx-24 mt-24">
                <div class="w-1/2 text-[#023047] flex flex-col justify-center gap-y-2">
                    <h3 class="font-bold">Raih Impian dengan Asyik.<br>
                        Apa itu Intelligo Job Connect?</h3>
                    <p>Intelligo ID bertujuan untuk membuka dan menyalurkan potensi talent agar mereka lebih mudah
                        menjemput karir mereka.
                        Salah satu cara kami melakukanya adalah dengan membantu talent menyempurnakan dokumen seperti CV
                        dan Portofolio
                        menggunakan konektor pekerjaan kami sendiri, Intelligo Job Connect.</p>
                    <button class="bg-[#023047] rounded-3xl p-3 text-white w-1/2 hover:bg-orange-500">Join Intelligo
                        Sekarang</button>
                </div>
                <div class="w-1/2">
                    <img src="../assets/imgHeroJob.png" alt="">
                </div>
            </div>

        </div>
    </div>

    <FooterComp />
</template>

<script>
import NavbarComp from "./NavbarComp.vue";
import FooterComp from "./FooterComp.vue";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";

export default {
    name: `DetailEvent`,
    data() {
        return {
            id: this.$route.query.event,
            user: false,
            event: {
                benefits: [],
                registration_flow: [],
                curriculums: [],
                mentor: [],
                faq: [],
            },

        }
    },
    components: {
        NavbarComp,
        FooterComp,
        Splide,
        SplideSlide,
        SplideTrack,
    },
    methods: {
        goto(refName) {
            var element = this.$refs[refName];
            console.log(element);
            var top = element.offsetTop;

            window.scrollTo(0, top);
        },
        fungsiLoadUser: async function () {
            const response = (await this.$api.get(`/auth/check`)).data
            if (response.status) {
                this.user = true
            }

            this.fungsiLoadContent()
        },
        fungsiLoadContent: async function () {
            if (this.user) {
                this.event = (await this.$api.get(`/event/${this.id}`)).data.data
            } else {
                this.event = (await this.$api.get(`/get-event/${this.id}`)).data.data
            }
        },
        fungsiActionLink() {
            window.location = 'https://dash.intelligo.id/'
        }
    },
    mounted() {
        this.fungsiLoadUser()
        let tailwind = document.createElement('script')
        tailwind.setAttribute('src', 'https://cdn.tailwindcss.com')
        document.head.appendChild(tailwind)
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

body {
    margin: 0;
    background-color: white;
    font-family: 'Poppins', sans-serif;
}

.bg-jc {
    background-image: url("../assets/bg-jobConnector.jpeg");
}

#main {
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;
}


/* Show the dropdown menu on hover */
#article h4 {
    /* margin-top: 40px; */
    font-size: 26px;
    font-weight: 600;
    color: #FF5400;
}

#article h3 {
    font-size: 32px;
    font-weight: 700;
    color: #023047;
}
</style>